import {ENV} from '@utils/constants'

// These need to be a subset of the dropdown options in the Hubspot property
// https://app.hubspot.com/property-settings/6588538/properties?type=0-1&search=lead&action=edit&property=lead_source
export enum LeadSource {
  leadFlow = 'lead_flow',
  tempeRentalApplication = 'tempe_rental_application',
  landingPageBanner = 'landing_page_banner',
}

export let HUBSPOT_MEETING_URL: string
export let HUBSPOT_SCHEDULE_A_TOUR_URL: string
if (ENV === 'production') {
  HUBSPOT_MEETING_URL = 'https://meetings.hubspot.com/culdesac-tempe/culdesac-tempe-leasing-call'
  HUBSPOT_SCHEDULE_A_TOUR_URL = 'https://meetings.hubspot.com/culdesac-tempe/culdesac-leasing-tour'
} else {
  HUBSPOT_SCHEDULE_A_TOUR_URL = 'https://meetings.hubspot.com/lane20'
  HUBSPOT_MEETING_URL = 'https://meetings.hubspot.com/lane20'
}

export const LEAD_FLOW_MODAL_STATE_KEY = 'lead-flow-modal-state-key'
